import { useQueries, useQuery } from '@tanstack/react-query';
import { IPagedCollection, UserSessionContext } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { ZoomMeetingView } from '../../models/Zoom';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'lead/demos/<demoId>/recordings';

type Params = {
	demoId: string;
	meta?: LevStandardQueryMeta;
	staleTime?: number;
	enabled?: boolean;
};

const getQueryConfig = (userSession: UserSessionContext, params: Params) => {
	return {
		queryKey: [BASE_QUERY_KEY, params.demoId],
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<IPagedCollection<ZoomMeetingView>>(
				`lead/demos/${params.demoId}/recordings`,
				'GET'
			);
		},
		staleTime: params.staleTime,
		meta: params.meta,
		enabled: params.enabled,
	};
};

export function useLeadDemoRecordingsQuery(params: Params) {
	const userSession = useUserSession();
	return useQuery(getQueryConfig(userSession, params));
}

export function useLeadDemoRecordingQueries(params: { demoIds: string[] } & Omit<Params, 'demoId'>) {
	const { demoIds, ...queryParams } = params;
	const userSession = useUserSession();
	return useQueries({
		queries: demoIds.map(demoId => getQueryConfig(userSession, { demoId, ...queryParams })),
	});
}
